import { render, staticRenderFns } from "./classListCtr.vue?vue&type=template&id=3c63c3a1&scoped=true"
import script from "./classListCtr.vue?vue&type=script&lang=js"
export * from "./classListCtr.vue?vue&type=script&lang=js"
import style0 from "./classListCtr.vue?vue&type=style&index=0&id=3c63c3a1&prod&lang=less"
import style1 from "./classListCtr.vue?vue&type=style&index=1&id=3c63c3a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c63c3a1",
  null
  
)

export default component.exports